<template>
  <div class="table-responsive">
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th>
            Rank
          </th>
          <th class="ranked-fragrance-image" />
          <th>
            Fragrance
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="fragrance in fragrances" :key="fragrance.name">
          <td>
            {{ fragrance.rank }}
          </td>
          <td class="ranked-fragrance-image">
            <a :href="fragrance.path">
              <img :src="fragrance.image" height="100" width="100" />
            </a>
          </td>
          <td>
            <a :href="fragrance.path">
              {{ fragrance.name }}
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    props: {
      fragrances: { type: Array, required: true }
    }
  };
</script>
